import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/**
 * Empty-state hero shown when the authenticated user has no messages yet.
 *
 * Post-Signup Immigration Activation Fix (2026-02-20):
 *   Replaced the LeadWing productivity framing with HussarAi
 *   immigration-record CTAs. A brand-new Basic user now sees:
 *     · Primary CTA  → /mos-precheck (first meaningful action)
 *     · Secondary CTA → /moje-akta-imigracyjne
 *     · Tertiary link → /bezpieczenstwo-i-zgodnosc
 *   The voice-nudge + suggested prompt chips remain (chips now carry
 *   immigration-record starter prompts sourced from `examples.items`).
 */
const EmptyState = ({ isPremium, promptsUsed, suggestedPrompts, onPromptClick }) => {
  const { t } = useTranslation();
  const remaining = 10 - (promptsUsed || 0);

  return (
    <>
      <div className="hussar-empty-state" data-testid="app-empty-state">
        <h1 className="hussar-app-title" data-testid="app-empty-state-title">
          {t('app.intro.title')}
        </h1>
        <p className="hussar-app-subtitle" data-testid="app-empty-state-subtitle">
          {t('app.intro.subtitle')}
        </p>

        <div className="hussar-empty-state-ctas" data-testid="app-empty-state-ctas">
          <Link
            to="/mos-precheck"
            className="hussar-empty-state-cta-primary"
            data-testid="app-empty-state-cta-mos-precheck"
          >
            {t('app.intro.ctaPrimary')}
          </Link>
          <Link
            to="/moje-akta-imigracyjne"
            className="hussar-empty-state-cta-secondary"
            data-testid="app-empty-state-cta-moje-akta"
          >
            {t('app.intro.ctaSecondary')}
          </Link>
          <Link
            to="/bezpieczenstwo-i-zgodnosc"
            className="hussar-empty-state-cta-tertiary"
            data-testid="app-empty-state-cta-bezpieczna-architektura"
          >
            {t('app.intro.ctaTertiary')}
          </Link>
        </div>

        {!isPremium && (
          <p className="hussar-usage-hint">
            {t('app.intro.promptsLeft', { count: remaining > 0 ? remaining : 0 })}
          </p>
        )}
        <button
          type="button"
          className="hussar-voice-nudge"
          data-testid="voice-nudge"
          onClick={() => {
            document.querySelector('[data-testid="voice-record-btn-start"]')?.click();
          }}
          aria-label={t('app.intro.voiceNudge')}
        >
          <span className="hussar-voice-nudge-dot" aria-hidden="true" />
          <span className="hussar-voice-nudge-text">{t('app.intro.voiceNudge')}</span>
        </button>
      </div>

      <div className="hussar-suggestions" data-testid="app-empty-state-suggestions">
        {suggestedPrompts.map((suggestion) => (
          <button
            key={suggestion}
            type="button"
            className="hussar-suggestion-chip"
            onClick={() => onPromptClick(suggestion)}
          >
            {suggestion}
          </button>
        ))}
      </div>
    </>
  );
};

export default EmptyState;
